var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"robot-nav-wrapper"},[_c(_vm.type,{tag:"component",attrs:{"nav-data":_vm.robotNav},on:{"click":_vm.handleCLick,"hook:mounted":_vm.onLoad}}),(_vm.html)?_c('span',{class:[_vm.isMobile ? 'robot-nav-err' : 'robot-nav-err-pc'],domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }